module.exports = __webpack_public_path__ + "img/10979910_L.18ad45fd.png";